var map = {
	"./1.png": 3189,
	"./6.png": 6370,
	"./Bhavya1.png": 8759,
	"./DINIKALOGOCROP.png": 2224,
	"./book2.png": 7115,
	"./capital.jpg": 4436,
	"./capitalsmall.jpg": 3831,
	"./coloura.jpg": 9970,
	"./colourb.jpg": 7987,
	"./colourc.jpg": 7697,
	"./computer1.jpg": 4341,
	"./computer2.jpg": 559,
	"./computer3.jpg": 482,
	"./cursive1.jpg": 2751,
	"./cursive2.jpg": 7922,
	"./cursive3.jpg": 2592,
	"./cursive4.jpg": 6453,
	"./cursive5.jpg": 7442,
	"./english1.jpg": 1867,
	"./english2.jpg": 7855,
	"./english3.jpg": 4433,
	"./english4.jpg": 2649,
	"./english5.jpg": 7849,
	"./english6.jpg": 9783,
	"./english7.jpg": 4140,
	"./english8.jpg": 3597,
	"./evs1.jpg": 1232,
	"./evs2.jpg": 4776,
	"./evs3.jpg": 5554,
	"./evs4.jpg": 6975,
	"./hindi8.jpg": 7677,
	"./maths1.jpg": 1995,
	"./maths2.jpg": 5042,
	"./maths3.jpg": 3779,
	"./maths4.jpg": 2976,
	"./maths5.jpg": 4923,
	"./numbera.jpg": 3355,
	"./science1.jpg": 3202,
	"./science2.jpg": 3385,
	"./science4.jpg": 7645,
	"./small.jpg": 4972,
	"./sst3.jpg": 7891,
	"./sst4.jpg": 9403,
	"./sst5.jpg": 5221,
	"./sst6.jpg": 9410,
	"./sst7.jpg": 4128,
	"./sst8.jpg": 7056,
	"./urdua.jpg": 682,
	"./urdub.jpg": 3376,
	"./urduc.jpg": 626,
	"./yellow.png": 7635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;